import store from "store2";
import { HighScore } from "../models/HighScore";
import i18next from "i18next";

export class Utils
{
    static getRandomInt(max: number) {
        return Math.floor(Math.random() * max);
    }

    static getRandomLetter(selection: string) {
        const lg = i18next.language;
        let letters = "";
        // https://www.sttmedia.com/characterfrequency-dutch
        if (lg == "nl") letters = "aaaaaaaabcdddddeeeeeeeeeeeeeeeeeeefggghhhiiiiijjkkkllllmmmnnnnnnnnnnoooooopprrrrrrssssttttttuuvvwwzz";
        // https://www3.nd.edu/~busiforc/handouts/cryptography/letterfrequencies.html
        if (lg == "en") letters = "aaaaaaaabbcccccdddeeeeeeeeeeeffgghhhiiiiiiiiklllllmmmnnnnnnnoooooooppprrrrrrrrsssssstttttttuuuuvwyy";
        let result = letters[this.getRandomInt(letters.length)];
        while(!this.isCorrectLetterType(result, selection)) {
            result = letters[this.getRandomInt(letters.length)];
        }
        return result;
    }

    static isCorrectLetterType(letter: string, selection: string) {
        let vowels = 0;
        let consonants = 0;
        selection.split('').forEach(char => {
            this.isVowel(char) ? vowels++ : consonants++;
        });

        const vowelPercentage = vowels / (vowels + consonants);
        if (vowelPercentage < 0.4 && !this.isVowel(letter)) {
            console.log("wrong letter");
            return false;
        }
        return true;
    }

    static isVowel(letter: string) {
        return "aeiou".includes(letter);
    }

    static msToTime(s: number) {
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
      
        return mins + ':' + secs.toString().padStart(2, '0');
    }

    static saveScore(score: number) {
        let highscores = store.get("highscores");
        if (highscores == null) highscores = [];
        const highscore = new HighScore();
        highscore.timestamp = new Date().getTime();
        highscore.score = score;
        highscores.push( highscore);
        store.set("highscores", highscores);
    }

    static getHighScores(): HighScore[] {
        return store.get("highscores");
    }

    static getTutorialDone(): boolean {
        return store.get("tutorial");
    }

    static setTutorialDone(t: boolean) {
        return store.set("tutorial", t);
    }
}